import { createI18n } from 'vue-i18n';

import { en as enLocale, zhHant as zhHKLocale, ko as koLocale } from 'vuetify/locale'
// 导入语言文件
import en from '@/locales/en.json';
import zhHK from '@/locales/zh-HK.json';
import ko from '@/locales/ko.json';

// 从本地存储获取当前语言，默认为英文
const locale = localStorage.getItem('language') || 'en';

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale,
  messages: {
    'en': {
        ...en,
        $vuetify: {
            ...enLocale,
            dataIterator: {
                rowsPerPageText: 'Items per page:',
                nextPage: 'Next page',  
                prevPage: 'Previous page',
                noResultsText: 'No results found',
                loadingText: 'Loading...',
                noDataText: 'No data available',
                pageText: '{0}-{1} of {2}',
            },
        }
    },
    'zhHant': {
        ...zhHK,
        $vuetify: {
            ...zhHKLocale,
            dataIterator: {
                rowsPerPageText: '每页数量:',
                nextPage: '下一頁',
                prevPage: '上一頁',
                noResultsText: '沒有結果',
                loadingText: '加載中...',
                noDataText: '沒有數據',
                pageText: '{0}-{1} 共 {2}',
            },
        }
    },
    'ko': {
        ...ko,
        $vuetify: {
            ...koLocale,
            dataIterator: {
                rowsPerPageText: '페이지당 항목:',
                pageText: '{0}-{1} 총 {2}',
                nextPage: '다음 페이지',
                prevPage: '이전 페이지',
                noResultsText: '결과가 없습니다',
                loadingText: '로드 중...',
                noDataText: '데이터가 없습니다',
            },
        }
    }
  }
});


export default i18n; 